<template>
  <div>
    <edit-page-header
      page="WOD"
      :date="form.date"
    >
      <el-button
        class="light-gray"
        @click="handleClickDelete"
      >
        삭제
      </el-button>
      <el-button
        class="black"
        @click="handleClickEdit"
      >
        수정
      </el-button>
    </edit-page-header>

    <div class="notice-form">
      <el-form
        :model="form"
        label-position="top"
        label-width="100px"
      >
        <el-form-item
          label="내용"
          prop="content"
        >
          <div
            class="notice-content"
            v-html="form.contents"
          />
        </el-form-item>
        <el-form-item style="width: 330px;">
          <el-upload
            action=""
            multiple
            :limit="5"
            name="image"
            :file-list="initialFileList"
          />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import dateFns from "date-fns";
import { convertRelativeHref } from "@/utils/etc";
import EditPageHeader from "@/components/EditPageHeader";
import { fiflboxApi } from '@/utils/api';

export default {
	name: "WorkoutViewForm",
	components: { EditPageHeader },
	data() {
		return {
			initialFileList: [],
			date: null,
			form: {
				date: "",
				title: "",
				contents: "",
				images: [],
			},
			workoutId: null,
		};
	},
	async created() {
		this.workoutId = this.$route.params.workoutId;
		await this.syncData();
    this.$nextTick(() => {
      convertRelativeHref(".notice-content a")
    })
	},
	methods: {
		handleClickEdit() {
			this.$router.push(`/wods/${this.workoutId}/edit`).catch(()=>{});
		},
		handleClickDelete() {
			return this.$confirm(
				"본 게시물을 삭제하시겠습니까?",
				"오늘의 운동 삭제",
				{
					confirmButtonText: "확인",
					cancelButtonText: "취소",
					showClose: false,
					customClass: "fifl-message-box",
					confirmButtonClass: "gray",
					cancelButtonClass: "white",
					closeOnPressEscape: false,
				}
			).then(async () => {
				try {
          await fiflboxApi.v1.deleteWods(this.workoutId);

					this.$message({
						type: "success",
						message: "오늘의 운동이 삭제됐습니다.",
					});

					this.$router.replace("/dashboard").catch(()=>{});
				} catch (err) {}
			});
		},
		async syncData() {
			let { data: notice } = await fiflboxApi.v1.getWodsById(this.workoutId);
			this.form = notice;
			this.initialFileList = notice.images.map(image => {
				return {
					name: image.filename,
					url: image.image,
				};
			});
		},
	},
};
</script>


<style lang="scss">
.notice-form {
	background-color: #ffffff;
	padding: 30px 25px;
	border-radius: 10px;

	.notice-title {
		height: 50px;
		line-height: 50px;
		border-radius: 5px;
		border: solid 1px #d3d3d3;

		font-size: 15px;
		color: #4a4a4a;
		letter-spacing: -0.8px;

		padding: 0 20px;
	}

	.notice-content {
		border-radius: 5px;
		border: solid 1px #d3d3d3;

		font-size: 15px;
		color: #4a4a4a;
		letter-spacing: -0.8px;

		padding: 20px;

		min-height: 300px;
	}
}
</style>
